import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { api } from "@/lib/api";

export default function Testimonials() {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    api.get("/testimonials").then((r) => setTestimonials(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <title>Öğrenci Yorumları — ZB Campus Muhasebe Akademisi</title>

      <section className="container-x py-20 md:py-28">
        <span className="section-eyebrow">Öğrenci Yorumları</span>
        <h1 className="font-display text-4xl md:text-5xl mt-4 leading-tight max-w-2xl">
          Onların hikayeleri, <span className="italic gold-gradient-text">yeni</span> başlangıçlar.
        </h1>
      </section>

      <section className="container-x pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: (i % 6) * 0.06 }}
              className="bg-surface border border-white/10 p-8 relative card-hover"
            >
              <Quote className="w-8 h-8 text-gold/30 mb-4" />
              <p className="text-white/85 leading-relaxed italic">"{t.quote}"</p>
              <div className="hairline my-5" />
              <div className="flex items-center gap-3">
                {t.avatar_url && (
                  <img src={t.avatar_url} alt={t.name} className="w-12 h-12 rounded-full object-cover border border-gold-30" />
                )}
                <div>
                  <div className="font-display text-lg">{t.name}</div>
                  <div className="text-xs text-white/50">{t.role}</div>
                </div>
                <div className="ml-auto flex items-center gap-0.5">
                  {[...Array(t.rating || 5)].map((_, i) => (
                    <Star key={i} className="w-3.5 h-3.5 fill-gold text-gold" />
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
        {testimonials.length === 0 && (
          <div className="text-center text-white/50 py-16">Henüz yorum bulunmuyor.</div>
        )}
      </section>
    </div>
  );
}
